export default __webpack_public_path__ + "volume_off-960-3ebfaee75f2c207cf866fc30b73b22d8.webp";